import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Bottom from "../Bottom";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import noticeimg from "../../assets/images/noticeimg.png";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useEffect } from "react";
import api from "../../utils/api";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const Notice = () => {
  const navigate = useNavigate();
  const [noticeList, setNoticeList] = React.useState([]);

  let i = 0;
  useEffect(() => {
    let params = { cusId: localStorage.getItem('userCusID') || '', pageNum: 0, searchWord: '' };

    let i = 0;
    while (true) { // 조건문
      let listCount = 0;
      params.pageNum = i;
      api.post(`customer/api/v1/getMobileNoticeList`, params).then(res => {
        setNoticeList((prev) => prev.concat(res.data.noticeList));
        listCount = res.data.noticeList.length;
      }).catch(function (error) {
        console.log(error)
      });

      if (listCount < 1) {
        break;
      }
      i++;
    }
  }, []);



  return (
    <Box>
      <Container sx={{ p: '0 !important', pb: '50px !important', bgcolor: '#F6F6F6', minHeight: '100vh', minWidth: 320 }}>
        <Box sx={{ bgcolor: '#d4e1fd', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, }} >
          {/* logo */}
          <Box position={'fixed'} width={'100%'} bgcolor={'#d4e1fd'} zIndex={999} maxWidth={'1200px'}>
            <Stack direction={'row'} >
              <Box>
                <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                  <Img alt="Dual" src="/dual.png" />
                </ButtonBase>
              </Box>
            </Stack>
          </Box>

          <Grid container spacing={2} direction='row' sx={{ mt: 6 }}>

            <Grid container item xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>
              <Typography sx={{ fontSize: '2.2rem', color: '#2e36a9', fontWeight: 900, }}>
                공지사항
              </Typography>
            </Grid>
            <Grid sx={{ width: '45%', mr: 1, pt: 0, pl: 0 }} justifyContent='center' alignContent={'center'}>
              <Img alt="care" src={noticeimg} />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ pt: 1 }}>
          <Typography sx={{ m: '20px auto 30px auto', width: '100%', textAlign: 'center', fontSize: 16, fontWeight: 600, color: '#555', }}>새로운 소식을 확인하세요.</Typography>
          <Box sx={noticeBox}>

            {noticeList.map((item: any, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>{item.title}</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}><CalendarMonthIcon sx={dateIcon} />{item.createDate}</Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    {item.content}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}

          </Box>
        </Box>
      </Container>

      <Bottom />
    </Box>
  );
}

const noticeBox = {
  mb: 4, ml: 2, mr: 2,
  boxSizing: 'border-box',
  '& .MuiAccordion-root:first-of-type': { borderTopLeftRadius: 20, borderTopRightRadius: 20, },
  '& .MuiAccordion-root:last-of-type': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, }
}

const noticeTitle = {
  fontSize: 14,
  fontWeight: 700,
  color: '#555',
  mb: 1,
  pr: 2,
  /*  overflow: 'hidden',
   textOverflow: 'ellipsis',
   display: '-webkit-box',
   '-webkitLineClamp': '2',
   '-webkitBoxOrient': 'vertical' */
}

const noticeDate = {
  fontSize: 12,
  color: '#777'
}

const dateIcon = {
  fontSize: 16,
  color: '#888',
  verticalAlign: 'sub',
  mr: '5px'
}

const noticeDetail = {
  fontSize: 14,
  color: '#555',
  whiteSpace: 'pre-wrap'
}

export default Notice;